import 'core-js';
import { createRoot } from 'react-dom/client';
import App from './App';
import RevStatsThemeProvider from './RevStatsThemeProvider';

const initReactApp = () => {
    const container = document.getElementById('revstats');
    const root = createRoot(container);

    root.render(
        <RevStatsThemeProvider>
            <App />
        </RevStatsThemeProvider>,
    );
};

// USE_MOCK_APIS is defined by Webpack based on the environment flag "USE_MOCK_APIS".
// eslint-disable-next-line no-undef
if (USE_MOCK_APIS) {
    import(/* webpackChunkName: "browserMock" */ './mocks/browser').then(({ worker }) => {
        (async () => {
            await worker.start({
                // Ignore logs when we hit APIs. We generally don't need this very often (Network tab is sufficient)
                quiet: true,
                // Ignored 'unhandled' requests as some come from external sources (images, webpack HMR) and it's generally obvious when data is missing...
                onUnhandledRequest: 'bypass',
            });
            initReactApp();
        })();
    });
} else {
    initReactApp();
}
